
import { Options, Vue } from "vue-class-component";
import address from "@/variable";
import axios from "axios";

@Options({
  components: {},
})
export default class Form extends Vue {
  doc: any = {};
  mounted() {
    if (this.$route.params.id != undefined) this.fetchData();
  }
  fetchData() {
    axios.get(`${address}/segment/${this.$route.params.id}`).then((response) => {
      this.doc = response.data;
    });
  }
  submitForm() {
    if (this.$route.params.id != undefined) {
      axios
        .patch(`${address}/segment/${this.doc._id}`, this.doc)
        .then((response) => {
          alert("แก้ไขข้อมูลแล้ว");
          this.$router.push("/cost");
        });
    } else {
      axios
        .post(`${address}/segment`, {
          ...this.doc,
        })
        .then((response) => {
          alert("บันทึกข้อมูลแล้ว");
          this.$router.push("/cost");
        });
    }
  }
}
